import { createSelector } from 'reselect';

import { OrderingSelectors, OrderingConstants } from 'polygon-ordering';
import type { RootState } from 'store';

const { getGatewayType } = OrderingSelectors;
const { PAYMENT_GATEWAY_TYPES } = OrderingConstants;

const getConfigMultiPaymentsAllowed = (state: RootState) => state.config.multiPaymentsAllowed;

export default createSelector(
  [getConfigMultiPaymentsAllowed, getGatewayType],
  (multiPaymentsAllowed, gatewayType) =>
    Boolean(multiPaymentsAllowed) && gatewayType !== PAYMENT_GATEWAY_TYPES.REDCAT_PAY,
);
